import ValidateDefaults from 'validation/ValidateDefaults';
import { getLocale } from 'services/LocalizationService';

export default class ValidateRecurlyHosted extends ValidateDefaults {
    constructor(obj) {
        super(obj);

        this.on = obj.on && Array.isArray(obj.on) ? obj.on : ['blur'];
    }

    validate(str) {
        return typeof str === 'string' && str.trim() === 'VALID';
    }

    static defaultMessage() {
        return getLocale('invalid');
    }
}
